import React from "react";
import { motion } from "framer-motion";
import useActiveSection, { SECTION_IDS } from "../hooks/useActiveSection";

const LABELS = {
  home: "Launch",
  about: "Origin",
  services: "Systems",
  stack: "Toolkit",
  projects: "Missions",
  youtube: "Broadcast",
  contact: "Rendezvous",
};

export default function JourneyRail() {
  const active = useActiveSection();

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <motion.nav
      aria-label="Section navigation"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1, duration: 0.6 }}
      className="journey-rail"
      style={{
        position: "fixed",
        right: 22,
        top: "50%",
        transform: "translateY(-50%)",
        zIndex: 60,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 16,
      }}
    >
      {SECTION_IDS.map((id) => {
        const isActive = active === id;
        return (
          <button
            key={id}
            onClick={() => scrollTo(id)}
            aria-label={`Go to ${LABELS[id]}`}
            style={{
              background: "none",
              border: "none",
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: 0,
            }}
          >
            <motion.span
              animate={{
                opacity: isActive ? 1 : 0,
                x: isActive ? 0 : 8,
              }}
              style={{
                fontFamily: "var(--font-mono)",
                fontSize: 11,
                letterSpacing: "0.06em",
                textTransform: "uppercase",
                color: "var(--accent)",
                whiteSpace: "nowrap",
              }}
            >
              {LABELS[id]}
            </motion.span>
            <motion.span
              animate={{
                scale: isActive ? 1.3 : 1,
                backgroundColor: isActive ? "#00e5ff" : "rgba(255,255,255,0.25)",
                boxShadow: isActive ? "0 0 10px #00e5ff" : "0 0 0 rgba(0,0,0,0)",
              }}
              style={{
                width: 8,
                height: 8,
                borderRadius: "50%",
                display: "block",
              }}
            />
          </button>
        );
      })}

      <style>{`
        @media (max-width: 860px) {
          .journey-rail { display: none !important; }
        }
      `}</style>
    </motion.nav>
  );
}
